import { gql } from '@apollo/client';

export const GET_PRODUCT_GROUPS = gql`
  query ProductGroup_findAll {
    ProductGroup_findAll {
      data {
        id
        name
        isActive
      }
    }
  }
`;
